import type {z} from "zod";
import {ChangeExpedientRepresentativeBody} from "@project/sdk/sales/zod";

export const changeExpedientRepresentativeFormSchema =
  ChangeExpedientRepresentativeBody.strict().extend({
    representative: ChangeExpedientRepresentativeBody.shape.representative.options[0]
      .strict()
      .nullable(),
  });
export type ChangeExpedientRepresentativeFormPayload = z.output<
  typeof changeExpedientRepresentativeFormSchema
>;
export const draftChangeExpedientRepresentativeFormSchema =
  changeExpedientRepresentativeFormSchema.partial();
export type DraftChangeExpedientRepresentativeFormPayload = z.output<
  typeof draftChangeExpedientRepresentativeFormSchema
>;
